import { create as createStore } from 'zustand';

interface IStore {
  isOpen: boolean;
  open: (name: string) => void;
  close: () => void;
  name: string;
}

export const useCreationTypeFlashcard = createStore<IStore>(set => ({
  isOpen: false,
  open: (name: string) => {
    set({ isOpen: true, name });
  },
  close: () => {
    set({ isOpen: false, name: '' });
  },
  name: ''
}));
